import React, { Component } from "react";
import "./../css/master.css";
import "./../css/index.css";
import axios from 'axios';
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var httpURL = "";
class Index extends Component {
  mounted = false;
  constructor(props) {
    super(props);
    this.state = {
      loader: "none",
      opacity: 1,
    };
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  login = () => {
    this.mounted = true;
    if (this.mounted) {
      this.setState({ loader: "block", opacity: 0.5 });
    }

    var queryString = require("querystring");
    var usernametrim = document.getElementById("usr").value;
    var passwordtrim = document.getElementById("pwd").value;
    var username = $.trim(usernametrim);
    var password = $.trim(passwordtrim);
    axios
      .post(
        httpURL + "/a/l/adminlogin",
        queryString.stringify({ adminEmail: username, password: password }),
        { withCredentials: true }
      )
      .then(async (response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success("Logged in Successfully!");
          console.log(JSON.stringify(response.headers))
          await localStorage.setItem('tokenid', response.headers.tokenid)
          sessionStorage.setItem("adminEmail", username);
          setTimeout(
            function () {
              this.props.history.push("/cs/maintainCompany");
            }.bind(this),
            2000
          );
        } else {
          toast.error(response.data.SvcMsg);
          this.setState({ loader: "none", opacity: 1 });
        }
        if (this.mounted) {
          this.setState({ loader: "none", opacity: 1 });
        }
      })
      .catch((error) => {
        toast.error(error);
        this.setState({ loader: "none", opacity: 1 });
      });
  };

  forGotPassword = () => {
    var queryString = require("querystring");
    var username = document.getElementById("usr").value;
    if (username === "") {
      toast.warning("Please enter email Id");
      return false;
    }
    this.setState({ loader: "block", opacity: 0.5 });
    axios
      .post(
        httpURL + "/a/l/forgotpassword",
        queryString.stringify({ adminEmail: username })
      )
      .then((response) => {
        sessionStorage.setItem("email", username);
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  enterLogin = (e) => {
    if (e.key === "Enter") {
      this.login();
    }
  };

  render() {
    httpURL = window.httpURL;
    return (
      <div
        className="container bg-img"
        style={{ paddingTop: 120, boxSizing: "borderBox" }}
      >
        <ToastContainer autoClose={2000} hideProgressBar />
        <div
          style={{
            position: "fixed",
            width: 100,
            height: 100,
            marginLeft: -50,
            marginTop: -50,
            left: "50%",
            top: "50%",
            display: this.state.loader,
          }}
        >
          <img src={require("../images/loader.gif")} alt="Loader..." />
        </div>
        <div
          className="loginFormDiv padding-remove"
          style={{ opacity: this.state.opacity }}
        >
          <div className="formHead">
            <img
              src={require("../images/logo1.png")}
              style={{ width: "20%", height: "16%", margin: 10 }}
            />
            <div className="formHeadLabel">
              <h2
                style={{
                  textAlign: "center",
                  color: "#4682B4",
                  fontSize: "25px",
                  marginTop: "20px",
                  fontWeight: "bold",
                }}
              >
                <span style={{ color: "#f37022" }}>CHANDRA</span>
                <span style={{ color: "black" }}> SILKS</span>
              </h2>
              <h5
                style={{
                  textAlign: "center",
                  color: "#f37022",
                  fontSize: "20px",
                  marginTop: "10px",
                }}
              >
                Login Here
              </h5>
            </div>
          </div>
          <form id="loginForm">
            <div
              className="form-group input-group"
              style={{ marginTop: 30, marginBottom: 40, width: "100%" }}
            >
              <span className="has-float-label">
                <input
                  autoComplete="off"
                  type="text"
                  className="form-control"
                  id="usr"
                  placeholder="Username"
                />
                <label htmlFor="usr">Username</label>
              </span>
            </div>
            <div
              className="form-group input-group"
              style={{ marginTop: 40, marginBottom: 30, width: "100%" }}
            >
              <span className="has-float-label">
                <input
                  type="password"
                  className="form-control"
                  id="pwd"
                  onKeyPress={this.enterLogin}
                  placeholder="Password"
                />
                <label htmlFor="pwd">Password</label>
              </span>
            </div>
            <div
              className="form-group"
              style={{ marginTop: 30, marginBottom: 40, width: "100%" }}
            >
              <span
                onClick={this.forGotPassword}
                style={{
                  fontSize: 18,
                  float: "right",
                  color: "#f37022",
                  cursor: "pointer",
                }}
                id="forgotPwd"
              >
                Forgot password
              </span>
            </div>
            <div style={{ marginTop: 90 }} className="text-center">
              <button
                style={{
                  width: 90,
                  height: 35,
                  fontSize: 18,
                  backgroundColor: "#f37022",
                }}
                type="button"
                className="btn btn-warning text-center"
                onClick={this.login}
                id="loginBtn"
              >
                Login
              </button>
            </div>
          </form>
        </div>
        <span className="websiteLink">
          <a target="_blank" href="https://www.kmsgtech.com">
            Powererd By KMSG Technologies
          </a>
        </span>
      </div>
    );
  }
}

export default Index;
